import LocationService from "pro-features/components/Modals/src/UnlockModal/LocationService";
import HooksModalV5Key from "app/constants/HooksModalV5Key";
import { openHooksModalV5 } from "app/services/ModalService";

export const showIntentMoreTopicsHook = (): void => {
    openHooksModalV5(
        HooksModalV5Key.SalesSolutionIntentDefault,
        `${LocationService.getCurrentLocationTracking()}`,
        "IntentBanner",
    );
};

export const showIntentUpsellTopicHook = (): void => {
    openHooksModalV5(
        HooksModalV5Key.SalesSolutionIntentUpsellDefault,
        `${LocationService.getCurrentLocationTracking()}`,
        "IntentUpsellBanner",
    );
};
